/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable react/jsx-one-expression-per-line */
import { staticPercent, tooltipValuesStr } from '../formatCharts/handleCustomValue';
import compare from '../../../../utils/functions/sorting';

import {
  CustomTooltipContainer,
  ColorLabelSymbol,
  TooltipColumn,
  TooltipRow,
  DrilldownTip,
} from './styled/KpiCreate.styled';

const BarTooltip = ({ tData, styleConfig, hasDrilldown }) => (
  <CustomTooltipContainer key={tData.id}>
    <TooltipColumn>
      {!tData.isTotal && (
        <TooltipRow>
          <ColorLabelSymbol color={tData.color} />
          <span>
            {`${tData.id} - ${tData.indexValue}: `}
            <strong>
              {tooltipValuesStr(
                tData.data[`${tData.id}`] ?? 0, tData.data[`${tData.id}-value2`] ?? 0, styleConfig,
              )}
            </strong>
          </span>
        </TooltipRow>
      )}
      {Boolean(styleConfig?.ExtraLineControl !== 'no-line' && styleConfig?.LayoutControl !== 'horizontal') && (
        <TooltipRow>
          <span>
            {'Total: '}
            <strong>
              {tooltipValuesStr(tData.data.value ?? 0, tData.data.value2 ?? 0, styleConfig)}
            </strong>
          </span>
        </TooltipRow>
      )}
      {hasDrilldown && !tData.offBar && (
        <DrilldownTip>
          Clique para ver mais detalhes
        </DrilldownTip>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const LineToolTip = ({ tData, styleConfig, hasDrilldown }) => (
  <CustomTooltipContainer key={tData.serieId}>
    <TooltipColumn>
      <TooltipRow>
        <ColorLabelSymbol color={tData.seriesColor} />
        <span>
          {`${tData.seriesId} - ${tData.data.x}: `}
          <strong>
            {tooltipValuesStr(tData.data.value, tData.data.value2, styleConfig)}
          </strong>
        </span>
      </TooltipRow>
      {hasDrilldown && (
        <DrilldownTip>
          Clique para ver mais detalhes
        </DrilldownTip>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const PieToolTip = ({ tData, styleConfig, hasDrilldown }) => (
  <CustomTooltipContainer key={tData.label + tData.value}>
    <TooltipColumn>
      <TooltipRow>
        <ColorLabelSymbol color={tData.color} />
        <span>
          {`${tData.label}: `}
          <strong>
            {tooltipValuesStr(tData.data.value, tData.data.value2, styleConfig)}
          </strong>
        </span>
      </TooltipRow>
      {hasDrilldown && (
        <DrilldownTip>
          Clique para ver mais detalhes
        </DrilldownTip>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const RadarToolTip = ({ tData, styleConfig }) => {
  const auxData = tData?.data;
  auxData.sort((a, b) => compare(a.id, b.id));
  return (
    auxData.map((item) => (
      <CustomTooltipContainer key={item.index + item.id}>
        <ColorLabelSymbol color={item.color} />
        <span>
          {`${item.id} - ${tData.index}: `}
          <strong>
            {tooltipValuesStr(item.value, null, styleConfig)}
          </strong>
        </span>
      </CustomTooltipContainer>
    )));
};

const MapTooltip = ({ tData, styleConfig }) => (
  tData.feature.data
    ? (
      <CustomTooltipContainer key={tData.feature.label + tData.feature.value}>
        <ColorLabelSymbol color={tData.feature.color} />
        <span>
          {`${tData.feature.label}: `}
          <strong>
            {tooltipValuesStr(tData.feature.value, null, styleConfig)}
          </strong>
        </span>
      </CustomTooltipContainer>
    )
    : <></>
);

const RadialBarTooltip = ({ tData, styleConfig, hasDrilldown }) => (
  <CustomTooltipContainer key={tData.groupId}>
    <TooltipColumn>
      <TooltipRow>
        <ColorLabelSymbol color={tData.color} />
        <span>
          {`${tData.groupId} - ${tData.data.x}: `}
          <strong>
            {tooltipValuesStr(tData.data.value, tData.data.value2, styleConfig)}
          </strong>
        </span>
      </TooltipRow>
      {hasDrilldown && (
        <DrilldownTip>
          Clique para ver mais detalhes
        </DrilldownTip>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const CalendarTooltip = ({ tData, styleConfig }) => {
  const fDate = (d) => new Date(`${d} 00:00`).toLocaleDateString('pt-br');
  return (
    <CustomTooltipContainer key={tData.id}>
      <ColorLabelSymbol color={tData.color} />
      <span>
        {`${fDate(tData.day)}: `}
        <strong>
          {tooltipValuesStr(tData.data.value, tData.data.value2, styleConfig)}
        </strong>
      </span>
    </CustomTooltipContainer>
  );
};

const FunnelTooltip = ({ tData, styleConfig, hasDrilldown }) => {
  const dt = tData.part;
  return (
    <CustomTooltipContainer key={dt.data.label + dt.data.value}>
      <TooltipColumn>
        <TooltipRow>
          <ColorLabelSymbol color={dt.color} />
          <span>
            {`${dt.data.label}: `}
            <strong>
              {tooltipValuesStr(dt.data.value, dt.data.value2, styleConfig)}
            </strong>
          </span>
        </TooltipRow>
        {hasDrilldown && (
          <DrilldownTip>
            Clique para ver mais detalhes
          </DrilldownTip>
        )}
      </TooltipColumn>

    </CustomTooltipContainer>
  );
};

const WaffleTooltip = ({ tData, styleConfig }) => (
  <CustomTooltipContainer key={tData.label}>
    <ColorLabelSymbol color={tData.color} />
    <span>
      {`${tData.label}: `}
      <strong>
        {tooltipValuesStr(tData.data.value, tData.data.value2, styleConfig)}
      </strong>
    </span>
  </CustomTooltipContainer>
);

const BoxPlotTooltip = ({ tData, styleConfig, hasDrilldown }) => (
  <CustomTooltipContainer key={tData.label} style={{ flexDirection: 'column' }}>
    <TooltipColumn>
      <TooltipRow>
        <ColorLabelSymbol color={tData.color} />
        <span style={{ marginRight: 'auto' }}>
          {tData.subGroup !== tData.group ? `${tData.subGroup} - ` : ''}
          {tData.group}
        </span>
      </TooltipRow>
      <TooltipRow>
        <TooltipColumn>
          <span>
            Quantidade: <strong>{tData.data.n}</strong>
          </span>
          <span>
            Mínimo: <strong>{tooltipValuesStr(tData.data.extrema[0], null, styleConfig)}</strong>
          </span>
          <span>
            Média: <strong>{tooltipValuesStr(tData.data.mean, null, styleConfig)}</strong>
          </span>
          <span>
            Máximo: <strong>{tooltipValuesStr(tData.data.extrema[1], null, styleConfig)}</strong>
          </span>
          <span>
            Desvio: <strong>{tooltipValuesStr(tData.data.sd, null, styleConfig)}</strong>
          </span>
        </TooltipColumn>
        <TooltipColumn>
          <span>
            Limite Inferior: <strong>{tooltipValuesStr(tData.data.values[0], null, styleConfig)}</strong>
          </span>
          <span>
            1° Quartil: <strong>{tooltipValuesStr(tData.data.values[1], null, styleConfig)}</strong>
          </span>
          <span>
            Mediana: <strong>{tooltipValuesStr(tData.data.values[2], null, styleConfig)}</strong>
          </span>
          <span>
            3° Quartil: <strong>{tooltipValuesStr(tData.data.values[3], null, styleConfig)}</strong>
          </span>
          <span>
            Limite Superior: <strong>{tooltipValuesStr(tData.data.values[4], null, styleConfig)}</strong>
          </span>
        </TooltipColumn>
      </TooltipRow>
      {hasDrilldown && (
        <DrilldownTip>
          Clique para ver mais detalhes
        </DrilldownTip>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const ScatterPlotTooltip = ({ tData, styleConfig, hasDrilldown }) => (
  <CustomTooltipContainer key={tData.node.id}>
    <TooltipColumn>
      <TooltipRow>
        <ColorLabelSymbol color={tData.node.color} />
        <span>
          {`${tData.node.serieId}: `}
          <strong>
            {`X: ${tooltipValuesStr(tData.node.xValue, null, styleConfig)}, `}
            {`Y: ${tooltipValuesStr(tData.node.yValue, null, styleConfig)}`}
          </strong>
        </span>
      </TooltipRow>
      {hasDrilldown && (
        <DrilldownTip>
          Clique para ver mais detalhes
        </DrilldownTip>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const HistogramTooltip = ({ tData, styleConfig }) => {
  let val1 = styleConfig.DataFormatValueType === 'percentual' ? staticPercent(
    tData.data[`${tData.id}`],
    styleConfig.InteractiveDecimals,
    styleConfig.InteractiveSeparadorNumericoCasasPercentuais,
  ) : tData.data[`${tData.id}`];
  if (styleConfig.DataFormatValueTypeAlt !== 'none') {
    val1 += ` (${styleConfig.DataFormatValueTypeAlt === 'percentual' ? staticPercent(
      tData.data[`${tData.id}-value2`],
      styleConfig.InteractiveDecimals,
      styleConfig.InteractiveSeparadorNumericoCasasPercentuais,
    ) : tData.data[`${tData.id}-value2`]})`;
  }
  return (
    <CustomTooltipContainer key={tData.id}>
      <TooltipColumn>
        <TooltipRow>
          <ColorLabelSymbol color={tData.color} />
          <span>
            {`]${tooltipValuesStr(tData.data.min, null, styleConfig)}; `}
            {`${tooltipValuesStr(tData.data.max, null, styleConfig)}]: `}
            <strong>
              {val1}
            </strong>
          </span>
        </TooltipRow>
      </TooltipColumn>
    </CustomTooltipContainer>
  );
};

const ParetoTooltip = ({ tData, styleConfig }) => (
  <CustomTooltipContainer key={tData.id}>
    <TooltipColumn>
      <TooltipRow>
        <ColorLabelSymbol color={tData.color} />
        <span>
          {`${tData.id} - ${tData.indexValue}: `}
          <strong>
            {tooltipValuesStr(tData.value, null, styleConfig)}
          </strong>
        </span>
      </TooltipRow>
      <TooltipRow>
        <span>
          {'Acumulado: '}
          <strong>
            {`${tooltipValuesStr(tData.data.lineAbsolute ?? 0, null, styleConfig)} `}
            {`(${staticPercent(tData.data.linePercent, styleConfig?.InteractiveDecimals, styleConfig?.InteractiveSeparadorNumericoCasasPercentuais)})`}
          </strong>
        </span>
      </TooltipRow>
    </TooltipColumn>
  </CustomTooltipContainer>
);

const BulletTooltip = ({ tData, styleConfig }) => (
  <CustomTooltipContainer key={tData.v0}>
    <TooltipColumn>
      {tData.v1 !== undefined ? (
        <TooltipRow>
          <ColorLabelSymbol color={tData.color} />
          <span>
            <strong>
              {styleConfig.InteractiveFormat === 'size' && (
                tooltipValuesStr(tData.v1 - tData.v0, null, styleConfig)
              )}
              {styleConfig.InteractiveFormat === 'stacked' && (
                tooltipValuesStr(tData.v1, null, styleConfig)
              )}
              {styleConfig.InteractiveFormat === 'interval' && (
                `]${
                  tooltipValuesStr(tData.v0, null, styleConfig)
                }; ${
                  tooltipValuesStr(tData.v1, null, styleConfig)
                }]`
              )}
            </strong>
          </span>
        </TooltipRow>
      ) : (
        <TooltipRow>
          <ColorLabelSymbol color={tData.color} />
          <span>
            <strong>{tooltipValuesStr(tData.v0, null, styleConfig)}</strong>
          </span>
        </TooltipRow>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const GaugeTooltip = ({ tData, styleConfig }) => (
  <CustomTooltipContainer key={tData.groupId}>
    <TooltipColumn>
      {tData.needle !== undefined ? (
        <TooltipRow>
          <span>
            {'Ponteiro: '}
            <strong>
              {tooltipValuesStr(tData.needle.value, tData.needle.value2, styleConfig)}
            </strong>
          </span>
          {tData.category !== undefined && (
            <>
              <span style={{ margin: '0 4px' }}>&#129030;</span>
              <ColorLabelSymbol color={tData.color} />
              <span>
                {tData.category}
              </span>
            </>
          )}
        </TooltipRow>
      ) : (
        <TooltipRow>
          <ColorLabelSymbol color={tData.color} />
          <span>
            {`${tData.category}: `}
            <>
              <strong>
                {styleConfig.LabelFormat === 'size' && (
                  tooltipValuesStr(tData.data.value, tData.data.value2, styleConfig)
                )}
                {styleConfig.LabelFormat === 'stacked' && (
                  tooltipValuesStr(tData.data.stacked, tData.data.stacked2, styleConfig)
                )}
                {styleConfig.LabelFormat === 'interval' && (
                  `]${
                    tooltipValuesStr(
                      tData.data.stacked - tData.data.value,
                      tData.data.stacked2 - tData.data.value2,
                      styleConfig,
                    )
                  }; ${
                    tooltipValuesStr(tData.data.stacked, tData.data.stacked2, styleConfig)
                  }]`
                )}
              </strong>
            </>
          </span>
        </TooltipRow>
      )}
    </TooltipColumn>
  </CustomTooltipContainer>
);

const customTooltip = (tData, type, styleConfig, hasDrilldown) => {
  switch (type) {
    case 'bar': return BarTooltip({ tData, styleConfig, hasDrilldown });
    case 'line': return LineToolTip({ tData, styleConfig, hasDrilldown });
    case 'pie': return PieToolTip({ tData: tData.datum, styleConfig, hasDrilldown });
    case 'radar': return RadarToolTip({ tData, styleConfig });
    case 'map': return MapTooltip({ tData, styleConfig });
    case 'radialbar': return RadialBarTooltip({ tData: tData.bar, styleConfig, hasDrilldown });
    case 'calendar': return CalendarTooltip({ tData, styleConfig });
    case 'waffle': return WaffleTooltip({ tData, styleConfig });
    case 'funnel': return FunnelTooltip({ tData, styleConfig, hasDrilldown });
    case 'boxplot': return BoxPlotTooltip({ tData, styleConfig, hasDrilldown });
    case 'scatterplot': return ScatterPlotTooltip({ tData, styleConfig, hasDrilldown });
    case 'histogram': return HistogramTooltip({ tData, styleConfig });
    case 'pareto': return ParetoTooltip({ tData, styleConfig });
    case 'bullet': return BulletTooltip({ tData, styleConfig });
    case 'gauge': return GaugeTooltip({ tData: tData.bar, styleConfig });
    default: return null;
  }
};

export default customTooltip;
